import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Box, Flex } from 'rebass';
import { Card, Button, Divider, Icon, Image, Message } from 'semantic-ui-react';
import { Form, Input } from 'formsy-semantic-ui-react';
import _ from 'lodash';
import ReactGA from 'react-ga';

import { Text } from '../Base';
import { COLOR } from '../Theme';

// import SuggestApp from './SuggestApp';
import { resolveErrorCode } from './errorCodeUtil';

import { errorLabel } from 'Util/form';

const StyledCard = styled(Card)`
  &.ui.card {
    border-radius: 0;
    width: 100%;
    min-width: 320px;
  }
  &.ui.card > .content {
    ${'' /* align-items: center; */};
  }
`;

const Link = styled(Text)`
  cursor: pointer;
  &:hover {
    color: ${COLOR.primary};
    text-decoration: underline;
  }
`;

const FWButton = styled(Button)`
  width: 100%;
`;

const SImage = styled(Image)`
  &&&& {
    display: block;
    max-width: 210px;
    margin: 16px auto 8px;
  }
`;

const IconBot = styled(props => <i {...props} className={`tcst-tcasbot ${props.className}`} />)`
  font-size: 140%;
  vertical-align: sub;
  margin-right: 4px;
  line-height: 14px !important;
`;

const FormBox = styled(Box)`
  max-width: 300px;
`;

class LoginForm extends Component {
  static propTypes = {
    logoUrl: PropTypes.string,
    onEmailLoginClick: PropTypes.func,
    onFacebookLoginClick: PropTypes.func,
    handleForgotPassword: PropTypes.func,
    onRegisterClick: PropTypes.func,
    errorCode: PropTypes.string,
    loading: PropTypes.bool,
  };

  static defaultProps = {
    logoUrl: '/images/tcaster_logo.png',
    onEmailLoginClick: () => {},
    onFacebookLoginClick: () => {},
    onRegisterClick: () => {},
    handleForgotPassword: () => {},
  };

  constructor(props) {
    super(props);
    this.login = _.throttle(this.login, 1000);
    this.handleFBLogin = _.throttle(this.handleFBLogin, 1000);
  }

  login = form => {
    try {
      ReactGA.event({
        category: 'AUTH',
        action: 'Login with email',
      });
    } catch (err) {
      console.log('ga error:', err);
    }
    this.props.onEmailLoginClick(form);
  };

  handleFBLogin = () => {
    try {
      ReactGA.event({
        category: 'AUTH',
        action: 'Login with Facebook',
      });
    } catch (err) {
      console.log('ga error:', err);
    }
    this.props.onFacebookLoginClick();
  };

  handleRegister = () => {
    this.props.onRegisterClick();
  };

  handleForgotPassword = () => {
    this.props.onForgotPasswordClick();
  };
  renderEmailLogin() {
    const { loading } = this.props;
    return (
      <Form onValidSubmit={this.login}>
        <Form.Field>
          <Text is="label" fontWeight={400} style={{ fontWeight: 400 }}>
            อีเมล
          </Text>
          <Input
            name="username"
            required
            validations="isEmail"
            validationErrors={{
              isEmail: 'อีเมลต้องอยู่ในรูปแบบของ username@domain.com',
              isDefaultRequiredValue: 'กรุณาใส่อีเมล',
            }}
            placeholder=""
            errorLabel={errorLabel}
          />
        </Form.Field>
        <Form.Field>
          <Text is="label" fontWeight={400} style={{ fontWeight: 400 }}>
            รหัสผ่าน
          </Text>
          <Input
            name="password"
            required
            type="password"
            placeholder=""
            validationErrors={{
              isDefaultRequiredValue: 'กรุณาใส่รหัสผ่าน',
            }}
            errorLabel={errorLabel}
          />
        </Form.Field>
        <Link is="a" color="primary" onClick={this.handleForgotPassword}>
          ลืมรหัสผ่าน
        </Link>
        <Box mb={3} />
        <FWButton
          primary
          circular
          size="medium"
          type="submit"
          content={
            <span style={{ fontWeight: 400 }}>
              <IconBot />
              เข้าสู่ระบบ
            </span>
          }
          loading={loading}
          disabled={loading}
        />
      </Form>
    );
  }

  render() {
    const { logoUrl, errorCode, loading } = this.props;
    return (
      <StyledCard>
        <Card.Content>
          <SImage src={logoUrl} centered />
          <FormBox pb={3} mx="auto" pt={4}>
            <FWButton
              circular
              size="medium"
              color="facebook"
              onClick={this.handleFBLogin}
              content={
                <span style={{ fontWeight: 400 }}>
                  <Icon name="facebook" />
                  เข้าสู่ระบบด้วย Facebook
                </span>
              }
              loading={loading}
              disabled={loading}
            />
            <Divider horizontal>
              <Text fontWeight={300}>หรือ</Text>
            </Divider>
            <Box mb={1}>
              <Text fontWeight={500} textAlign="center">
                เข้าสู่ระบบด้วย TCASter Account
              </Text>
            </Box>
            {errorCode && <Message negative>{resolveErrorCode(errorCode)}</Message>}
            {this.renderEmailLogin()}
            <Box mb={3} />
            <Flex justifyContent="center">
              <Text pr={2}>มาใหม่ใช่มั้ย</Text>
              <Link pr={2} is="a" color="primary" onClick={this.handleRegister}>
                ลงทะเบียน
              </Link>
              <Text>เลย</Text>
            </Flex>
          </FormBox>
        </Card.Content>
      </StyledCard>
    );
  }
}

export default LoginForm;
